import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { apiService } from '~/shared/api'
import type {
  Autopurchase,
  CreateAutopurchasePayload,
} from '~/entities/autopurchases/model/types'

export class AutopurchasesService {
  static getAutopurchases = async (
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<Autopurchase[]>> => {
    return apiService.get('/autopurchases', config)
  }

  static createAutopurchase = async (
    data: CreateAutopurchasePayload,
  ): Promise<AxiosResponse<Autopurchase>> => {
    return apiService.post('/autopurchases', data)
  }

  static deleteAutopurchase = async (id: string): Promise<AxiosResponse> => {
    return apiService.delete(`/autopurchases/${id}`)
  }
}
